import React, {useEffect, useState} from 'react';
import {useForm} from 'react-hook-form';
import {Button} from 'react-bootstrap';
import Popover from 'react-bootstrap/Popover';
import {observer} from 'mobx-react-lite';
import {useStore} from '../../store';
import {
  PopoverWrapper,
  DeskPopoverDiv,
  TitleDiv,
  Title,
  CreateButton,
  Input,
  AddButton,
  MobilePopoverDiv,
} from './styles';
import UpgradeModal from '../UpgradeModal';

const CoursePlaylistPopover = observer(
  ({onExisting, onNew, allPlaylist, props, courseVideos, userState, showUpgradeModal, onHideUpgradeModal}: any) => {
    const [isNew, setIsNew] = useState(true);
    const [isAdd, setIsAdd] = useState(false);
    const [checkCount, setCheckCount] = useState(0);
    const [isExisting, setIsExisting] = useState(false);
    const [editablePlaylists, setEditablePlaylists] = useState([]);
    const [isShowAddPlaylistModal, setShowAddPlaylistModal] = useState(false);

    const {accountStore, playlistStore} = useStore();
    const {account, userSettings} = accountStore;
    const desktopUpdateForm = useForm();
    const mobileUpdateForm = useForm();
    const {register: createRegister, handleSubmit: createSubmit, formState: createFormState, watch} = useForm({
      mode: 'onChange',
    });
    const watchField = watch('listname');
    const [allPlaylists, setallPlaylists] = useState(playlistStore.playlist);

    useEffect(() => {
      if (allPlaylist === undefined) playlistStore.getAllPlaylists();
      else if (allPlaylist?.length > 0) setIsNew(false);
    }, [allPlaylist, playlistStore]);

    useEffect(() => {
      setallPlaylists(playlistStore.playlist);
    }, [playlistStore.playlist]);

    useEffect(() => {
      playlistStore.getAllPlaylists();
    }, [playlistStore]);

    useEffect(() => {
      if (allPlaylists?.length > 0) setIsNew(false);
      setEditablePlaylists(allPlaylists?.filter(p => p.user_id == account.id));
    }, [account.id, allPlaylists]);

    const handleAdd = data => {
      onNew(data);
      document.body.click();
    };
    const updatePlaylist = async formData => {
      const data = await Object.keys(formData).map(key => ({
        playlistId: key,
        value: formData[key],
      }));
      onExisting(data);
      document.body.click();
    };

    useEffect(() => {
      let cumulative = 0;
      allPlaylists?.forEach(item => {
        const playlistids = item?.videos.map(video => +video.id) || [];
        if (courseVideos?.every(cv => playlistids.includes(+cv.id))) {
          cumulative += 1;
        }
      });
      if (cumulative) {
        setIsExisting(true);
        setCheckCount(cumulative);
      }
    }, [allPlaylists, courseVideos]);

    const addPlaylist = check => {
      if (check) {
        setCheckCount(checkCount + 1);
        setIsAdd(checkCount + 1 > 0);
      } else {
        setCheckCount(checkCount - 1);
        if (isExisting) {
          setIsAdd(true);
        } else {
          setIsAdd(checkCount - 1 > 0);
        }
      }
    };

    const showAddPlaylistModal = () => {
      setShowAddPlaylistModal(!isShowAddPlaylistModal);
    };

    const ifExisting = playlist => {
      const playlistids = playlist?.videos.map(video => +video.id) || [];
      return courseVideos?.every(cv => playlistids.includes(+cv.id));
    };

    const renderNewPlaylistForm = () => (
      <>
        <Title>Add to Playlist</Title>
        <form onSubmit={createSubmit(handleAdd)}>
          <Input
            placeholder="New Playlist Name"
            className={`w-100 ${watchField ? 'text-dark border' : 'bg-secondary border-0'}`}
            name="listname"
            ref={createRegister({required: true})}
            watch={watchField}
          />
          <AddButton
            className={`d-block mr-0 ml-auto ${
              watchField
                ? `border ${userSettings?.selected_theme === 'light' ? 'bg-primary' : 'bg-transparent'}`
                : 'bg-secondary border-0'
            }`}
            type="submit"
            disabled={!createFormState.isValid}
            watch={watchField}
          >
            Create and Add
          </AddButton>
        </form>
      </>
    );

    const renderExistingPlaylistForm = () => (
      <>
        <TitleDiv>
          <Title>Add to Playlist</Title>
          <CreateButton onClick={() => setIsNew(true)}>Create New Playlist</CreateButton>
        </TitleDiv>
        <form onSubmit={desktopUpdateForm.handleSubmit(updatePlaylist)}>
          <ul>
            {editablePlaylists?.map(item => {
              return (
                <li key={item.id}>
                  <input
                    type="checkbox"
                    id={item.id}
                    name={item.id}
                    onChange={e => addPlaylist(e.target.checked)}
                    onClick={e => !e.target.checked}
                    defaultChecked={ifExisting(item)}
                    ref={desktopUpdateForm.register()}
                  />
                  <label htmlFor={item.name}>{item.name}</label>
                </li>
              );
            })}
          </ul>
          <AddButton
            className={`d-block mr-0 ml-auto ${
              isAdd
                ? `border ${userSettings?.selected_theme === 'light' ? 'bg-primary' : 'bg-transparent'}`
                : 'bg-secondary border-0'
            }`}
            type="submit"
            disabled={!isAdd}
            watch={isAdd}
          >
            Save
          </AddButton>
        </form>
      </>
    );

    const renderMobilePlaylistForm = () => (
      <>
        <div className="title">Add to Playlist</div>
        <form onSubmit={mobileUpdateForm.handleSubmit(updatePlaylist)}>
          <ul>
            {editablePlaylists?.map(item => {
              return (
                <li key={item.id}>
                  <input
                    type="checkbox"
                    id={item.id}
                    name={item.id}
                    onChange={e => addPlaylist(e.target.checked)}
                    onClick={e => !e.target.checked}
                    defaultChecked={ifExisting(item)}
                    ref={mobileUpdateForm.register()}
                  />
                  <label htmlFor={item.name}>{item.name}</label>
                </li>
              );
            })}
          </ul>
          <button type="button" className="addPlylist" onClick={showAddPlaylistModal}>
            <b className="plus">+</b> Add a Playlist
          </button>
          <br />
          <Button type="submit" variant={isAdd ? 'primary' : 'secondary'} className="updateplylist">
            Save
          </Button>
        </form>
      </>
    );

    return (
      <PopoverWrapper>
        {userState ? (
          <Popover {...props} id="playlist-popover">
            <MobilePopoverDiv>
              {isShowAddPlaylistModal ? renderNewPlaylistForm() : renderMobilePlaylistForm()}
            </MobilePopoverDiv>
            <DeskPopoverDiv>
              <Popover.Content className="mw-100">
                {isNew ? renderNewPlaylistForm() : renderExistingPlaylistForm()}
              </Popover.Content>
            </DeskPopoverDiv>
          </Popover>
        ) : (
          <UpgradeModal access="playlist" isShow={showUpgradeModal} onHideModal={onHideUpgradeModal} />
        )}
      </PopoverWrapper>
    );
  },
);

export default CoursePlaylistPopover;
